import { unitSelectors as selector } from "../Selectors/index";
import Service from "../../Service/Item-master/itemUnit.service";
import { openSnackbar } from "./snackbarActions";

export const getUnit = () => {
  return {
    type: selector.GET,
  };
};

export const getUnitSuccess = (payload) => {
  return {
    type: selector.GET_SUCCESS,
    payload: payload,
  };
};

export const fetchUnit = () => {
  return async (dispatch) => {
    dispatch(getUnit());
    try {
      const res = await Service.getAll();
      dispatch(getUnitSuccess(res));
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };
};
